import { create } from "zustand";
import type { FormWithFields, FieldType } from "@/types/forms";

interface FormBuilderStore {
  form: FormWithFields | null;
  editingFieldId: string | null;
  newFieldType: FieldType | null;

  setForm: (form: FormWithFields) => void;
  clearForm: () => void;
  startEditField: (fieldId: string) => void;
  cancelEditField: () => void;
  startNewField: (type: FieldType) => void;
  cancelNewField: () => void;
}

export const useFormBuilderStore = create<FormBuilderStore>((set) => ({
  form: null,
  editingFieldId: null,
  newFieldType: null,

  setForm: (form) => set({ form, editingFieldId: null, newFieldType: null }),
  clearForm: () => set({ form: null, editingFieldId: null, newFieldType: null }),
  startEditField: (fieldId) => set({ editingFieldId: fieldId, newFieldType: null }),
  cancelEditField: () => set({ editingFieldId: null }),
  startNewField: (type) => set({ newFieldType: type, editingFieldId: null }),
  cancelNewField: () => set({ newFieldType: null }),
}));
